<template>
  <el-container style=" background:rgba(245,247,250,1);" >
    <el-aside width="200px" style="min-height: 600px;" ><HomeLeft/></el-aside>
    <el-main  >
        <router-view  />
    </el-main>

  </el-container>
</template>
<script>
  import HomeLeft from '@/components/home-left/home-left.vue'

  export default {
    components:{
      HomeLeft
    },
    created() {

    },
    data(){
      return{
        dialogVisible:false
      }
    }
  }
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/views/Layout/index.vue